import type { CampoUi } from '../dicionario/tipos';

type Linha = Record<string, unknown>;

/**
 * Descrição dos campos consulta (FK) resolvida no servidor: cada linha lida traz `_ref` ("código · descrição" da tabela de destino).
 * Devolve, por campo, id → descrição das linhas recebidas — nada de carregar a tabela de destino no cliente (D0-148 superado, D1-11).
 */
export function descricoesDe(linhas: readonly Linha[] | undefined, campos: readonly CampoUi[]): Record<string, Map<unknown, string>> {
  const mapa: Record<string, Map<unknown, string>> = {};
  for (const c of campos) if (c.tipo === 'consulta') mapa[c.nome] = new Map();
  for (const l of linhas ?? []) {
    const ref = l._ref as Record<string, string> | undefined;
    if (!ref) continue;
    for (const [campo, texto] of Object.entries(ref)) mapa[campo]?.set(l[campo], texto);
  }
  return mapa;
}
